import { Button } from '@iwoca/orion';
import Skeleton from 'react-loading-skeleton';

import ApprovedTick from './approvedTick.svg';
import { useGetBuyerSpendingLimit } from '../../../../api/lending/lapiHooks';
import { displayCurrency } from '../../../../utils/DisplayCurrency';
import {
  redirectToChooseProductPage,
  redirectToMyAccount,
} from '../../useRedirectToAccountPages';

export const SpendingLimitApproved = () => {
  const { spendingLimit, loadingSpendingLimit } = useGetBuyerSpendingLimit();

  const spendingLimits = spendingLimit?.data.spending_limits;

  if (loadingSpendingLimit) {
    return (
      <div className="min-h-screen">
        <div className="p-3xl">
          <div className="m-auto max-w-[400px] rounded-l border border-secondary-90 bg-white p-xl text-center xs:p-m">
            <img src={ApprovedTick} alt="Approved Tick" />
            <div className="mb-l text-2xl font-bold text-success-drk xs:text-xl xs:font-med">
              Great news!
            </div>
            <div className="mb-s text-m xs:text-s xs:font-med">
              You can spend up to
            </div>
            <div className="mb-xs text-6xl font-bold xs:text-5xl">
              £<Skeleton width={150} />
            </div>
            <hr className="mx-0 my-m border-t border-t-structure-80" />
            <div className="my-l text-left text-l font-bold xs:text-m">
              Think of your Spending Limit like a trade credit account
            </div>
            <ul className="flex flex-col justify-center p-0 text-left text-l font-reg xs:text-s">
              <li className="flex gap-m pl-m">
                <div>•</div>
                Find more iwocaPay suppliers in the Supplier Directory in your
                dashboard
              </li>
              <li className="flex gap-m pl-m">
                <div>•</div>Pay via terms that work for you
              </li>
              <li className="flex gap-m pl-m">
                <div>•</div>You and any iwocaPay supplier you engage with can
                see your available spending limit
              </li>
            </ul>
            <Button className="!px-2xl">Continue</Button>
          </div>
        </div>
      </div>
    );
  }

  if (!spendingLimits || spendingLimits.length === 0) {
    redirectToMyAccount();
    return null;
  }

  const highestSpendingLimit = spendingLimits.reduce((prev, current) => {
    return prev && prev.max_amount > current.max_amount ? prev : current;
  });

  return (
    <div className="min-h-screen">
      <div className="p-3xl">
        <div className="m-auto max-w-[400px] rounded-l border border-secondary-90 bg-white p-xl text-center xs:p-m">
          <img src={ApprovedTick} alt="Approved Tick" />
          <div className="mb-l text-2xl font-bold text-success-drk xs:text-xl xs:font-med">
            Great news!
          </div>
          <div className="mb-s text-m xs:text-s xs:font-med">
            You can spend up to
          </div>
          <div className="mb-xs text-6xl font-bold xs:text-5xl">
            {displayCurrency(highestSpendingLimit.max_amount, 0)}
          </div>
          <hr className="mx-0 my-m border-t border-t-structure-80" />
          <div className="my-l text-left text-l font-bold xs:text-m">
            Think of your Spending Limit like a trade credit account
          </div>
          <ul className="flex flex-col justify-center p-0 text-left text-l font-reg xs:text-s">
            <li className="flex gap-m pl-m">
              <div>•</div>
              Find more iwocaPay suppliers in the Supplier Directory in your
              dashboard
            </li>
            <li className="flex gap-m pl-m">
              <div>•</div>Pay via terms that work for you
            </li>
            <li className="flex gap-m pl-m">
              <div>•</div>You and any iwocaPay supplier you engage with can see
              your available spending limit
            </li>
          </ul>
          <Button
            className="!px-2xl"
            onClick={() => redirectToChooseProductPage()}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};
